import { render } from "./GroupLessons.vue?vue&type=template&id=f1ea0476&scoped=true&ts=true"
import script from "./GroupLessons.vue?vue&type=script&lang=ts"
export * from "./GroupLessons.vue?vue&type=script&lang=ts"

import "./GroupLessons.vue?vue&type=style&index=0&id=f1ea0476&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ea0476"]])

export default __exports__